import React       from 'react';
import HiddenInput from './HiddenInput';

const VendorSelected = ({ parameters, groupName }) => {
  const name = 'email';
  return (
    <HiddenInput
      name={name}
      value={parameters[name]}
      groupName={groupName} />
  );
};

VendorSelected.defaultProps = {
};

export default VendorSelected;
